// extracted by mini-css-extract-plugin
export default {"wrapper":"FestivalFooterCopyright_wrapper__Cx9ZJ"};